module.exports = __webpack_public_path__ + "static/media/0024.45574311.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48107/RAL/0024.png
// module id = 2654
// module chunks = 0